import React from 'react';
import BaseTable from './BaseTable';

const ChannelRemoved = () => {
  const tableHeaders = [
    "Removal Date",
    "Channel",
    "Author",
    "Title",
    "History"
  ]

  const rowNames = [
    "most_recent_activity",
    "channel_name",
    "admin_user_link",
    "title",
    "reminder_history"
  ]

  const columnAmountAndWidths = [
    {width: '180px'},
    null,
    {width: '160px'},
    null,
    {width: '100px', class: 'centered'}
  ]

  return <BaseTable
          tableHeaders={tableHeaders}
          state={"channel_removed"}
          rowNames={rowNames}
          historyElementColumnIndex={4}
          removeOrderingColumn={[4]}
          columnAmountAndWidths={columnAmountAndWidths}
          searchableColumnIndex={1}
          dateOrderColumn={0}
          />
}

export default ChannelRemoved;